// extracted by mini-css-extract-plugin
module.exports = {"fontFamily":"\"Calibre Regular\", Calibre, Roboto, sans-serif"};